// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"765":"361220db","787":"985894e4"}[chunkId] + ".chunk.js";
};